"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CELL_EDIT_TYPES = void 0;

var _find2 = _interopRequireDefault(require("lodash/find"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _TableCellLayout = _interopRequireDefault(require("./TableCellLayout"));

var _TableConstants = _interopRequireDefault(require("./TableConstants"));

var _Input = _interopRequireDefault(require("../Input/Input"));

var _Select = _interopRequireDefault(require("../Select/Select"));

var _StatusIcon = _interopRequireDefault(require("../Badge/StatusIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var CELL_EDIT_TYPES = {
  INPUT_TEXT: 'inputText',
  INPUT: 'input',
  SELECT: 'select'
};
/**
 * Cell inside Table
 */

exports.CELL_EDIT_TYPES = CELL_EDIT_TYPES;

var TableCell =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TableCell, _React$Component);

  function TableCell(props) {
    var _this;

    _classCallCheck(this, TableCell);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TableCell).call(this, props));
    _this.state = {
      // Edit cell with Select, this will hold the current selected row object
      selectedRow: null,
      selectInputValue: ''
    };
    return _this;
  }

  _createClass(TableCell, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          column = _this$props.column,
          columnKey = _this$props.columnKey,
          customProps = _this$props.customProps,
          editDirect = _this$props.editDirect,
          editRow = _this$props.editRow,
          rowData = _this$props.rowData,
          rowKey = _this$props.rowKey,
          rowIndex = _this$props.rowIndex;
      var isEditDirect = editDirect && editDirect.columnConfigs && editDirect.columnConfigs[column[columnKey]];
      var isEditRow = editRow && editRow.row === rowData[rowKey] && editRow.columnConfigs && editRow.columnConfigs[column[columnKey]];
      var cellAlert = this.getCellAlert();
      var hasCellWarning = cellAlert && cellAlert.type === _TableConstants.default.TABLE_ALERT.WARNING;
      var hasCellError = cellAlert && cellAlert.type === _TableConstants.default.TABLE_ALERT.ERROR;
      var cell,
          isCellEditable = false;

      if (isEditDirect) {
        var editDirectConfig = editDirect.columnConfigs[column[columnKey]];
        cell = this.editableCellCustomRender(editDirectConfig); // If application defines a custom render for this cell in the edit direct config
        // then render it, otherwise render the editable cell

        if (!cell) {
          cell = this.renderEditableCell(editDirectConfig, cellAlert);
          isCellEditable = true;
        }
      } else if (isEditRow) {
        var editRowConfig = editRow.columnConfigs[column[columnKey]];
        cell = this.editableCellCustomRender(editRowConfig); // If application defines a custom render for this cell in the edit row config
        // then render it, otherwise render the editable cell

        if (!cell) {
          cell = this.renderEditableCell(editRowConfig, cellAlert);
          isCellEditable = true;
        }
      } else {
        cell = this.renderCell(cellAlert); // Resetting these states to initial values as they are not needed
        // when we are not in edit row mode.

        this.state.selectInputValue = '';
        this.state.selectedRow = null;
      }

      var tdProps = {};

      if (column.renderProps) {
        var cellContent = rowData[column[columnKey]];
        var cellProps = column.renderProps(cellContent, rowData, rowIndex);

        if (cellProps) {
          tdProps = cellProps;
        }
      }

      if (customProps && customProps.cellProps) {
        var _cellProps = customProps.cellProps(column, rowData, rowIndex);

        if (_cellProps) {
          tdProps = _cellProps;
        }
      } // If another cell has a colspan or rowspan that spans into this cell, we
      // need a way to not show this cell. Since 0 is a valid value for colspan
      // and rowspan, we'll use -1 as a special value to not render this cell


      if (tdProps.colSpan === -1 || tdProps.rowSpan === -1) {
        return null;
      }

      return _react.default.createElement("td", _extends({
        className: (0, _classnames.default)(column.className, hasCellWarning ? 'has-cell-warning' : '', hasCellError ? 'has-cell-error' : '', isCellEditable ? '-editable' : ''),
        "data-text-align": column.textAlign
      }, tdProps), cell);
    }
    /**
     * Render cell content
     * @param {Object} cellAlert - Cell alert to be rendered
     * @returns {ReactElement} - Cell element
     */

  }, {
    key: "renderCell",
    value: function renderCell(cellAlert) {
      var _this$props2 = this.props,
          column = _this$props2.column,
          columnKey = _this$props2.columnKey,
          rowAlert = _this$props2.rowAlert,
          rowData = _this$props2.rowData,
          rowIndex = _this$props2.rowIndex;
      var cellContent = rowData[column[columnKey]];

      if (column.render) {
        cellContent = column.render(cellContent, rowData, rowIndex);
      }

      var beforeContent, afterContent;

      if (cellAlert) {
        afterContent = this.renderCellAlert(cellAlert);
      }

      if (rowAlert) {
        beforeContent = this.renderRowAlert(rowAlert);
      }

      return _react.default.createElement(_TableCellLayout.default, {
        content: cellContent,
        before: beforeContent,
        after: afterContent
      });
    }
    /**
     * Render the custom render function defined in columnConfig
     * @param {Object} columnConfig - Column config for editable cell
     * @returns {ReactElement} - Custom cell element
     */

  }, {
    key: "editableCellCustomRender",
    value: function editableCellCustomRender(columnConfig) {
      var _this$props3 = this.props,
          column = _this$props3.column,
          columnKey = _this$props3.columnKey,
          rowData = _this$props3.rowData,
          rowIndex = _this$props3.rowIndex;
      var cellValue = rowData[column[columnKey]];

      if (columnConfig.render) {
        var customNode = columnConfig.render(cellValue, rowData, rowIndex); // If columnConfig.render is defined and returns a node, then render it

        if (customNode) {
          return customNode;
        }
      }

      return null;
    }
    /**
     * Render editable cell
     * @param {Object} columnConfig - Column config for editable cell
     * @param {Object} cellAlert - Cell alert to be rendered
     * @returns {ReactElement} - Editable cell element
     */

  }, {
    key: "renderEditableCell",
    value: function renderEditableCell(columnConfig, cellAlert) {
      var _this2 = this;

      var _this$props4 = this.props,
          column = _this$props4.column,
          columnKey = _this$props4.columnKey,
          eventHandlers = _this$props4.eventHandlers,
          rowData = _this$props4.rowData,
          rowIndex = _this$props4.rowIndex;
      var cellValue = rowData[column[columnKey]];
      var cellAlertContent = this.renderCellAlert(cellAlert);
      var editableCell = null;

      switch (columnConfig.type) {
        case CELL_EDIT_TYPES.SELECT:
          var selectProps = columnConfig.selectProps ? columnConfig.selectProps(cellValue, rowData, rowIndex, this.state.selectInputValue) : {};

          if (!this.state.selectedRow) {
            this.state.selectedRow = (0, _find2.default)(selectProps.rowsData, function (row) {
              return row.label === cellValue;
            }) || {
              label: cellValue
            };
          }

          editableCell = _react.default.createElement(_Select.default, _extends({
            selectedRow: this.state.selectedRow,
            onSelectedChange: function onSelectedChange(selectedRow) {
              var value = selectedRow.label;

              _this2.setState({
                selectedRow: selectedRow,
                selectInputValue: ''
              });

              eventHandlers.handleEditDataChange(value, rowData, column, 'onChange');
            },
            inputProps: {
              appearance: 'borderless',
              value: this.state.selectInputValue,
              onChange: function onChange(event) {
                var value = event.currentTarget.value;

                _this2.setState({
                  selectInputValue: value
                });
              }
            }
          }, selectProps));
          break;

        case CELL_EDIT_TYPES.INPUT_TEXT:
        case CELL_EDIT_TYPES.INPUT:
        default:
          var inputProps = columnConfig.inputProps ? columnConfig.inputProps(cellValue, rowData, rowIndex) : {};
          editableCell = _react.default.createElement(_Input.default, _extends({
            appearance: "borderless",
            defaultValue: cellValue,
            onBlur: function onBlur(e) {
              var value = e.target.value;
              eventHandlers.handleEditDataChange(value, rowData, column, 'onBlur');
            },
            onChange: function onChange(e) {
              var value = e.target.value;
              eventHandlers.handleEditDataChange(value, rowData, column, 'onChange');
            },
            onFocus: function onFocus(e) {
              e.target.select();
            },
            suffix: cellAlertContent
          }, inputProps));
          break;
      }

      return editableCell;
    }
    /**
     * Render cell alert
     * @param {Object} cellAlert - Cell alert to be rendered
     * @returns {ReactElement} - Cell alert element
     */

  }, {
    key: "renderCellAlert",
    value: function renderCellAlert(cellAlert) {
      if (cellAlert) {
        var type;

        switch (cellAlert.type) {
          case _TableConstants.default.TABLE_ALERT.ERROR:
            type = _StatusIcon.default.STATUS_ICON_TYPES.ALERT;
            break;

          case _TableConstants.default.TABLE_ALERT.WARNING:
            type = _StatusIcon.default.STATUS_ICON_TYPES.WARNING;
            break;

          default:
            break;
        }

        if (type) {
          return _react.default.createElement(_StatusIcon.default, {
            className: "cell-alert-icon",
            type: type,
            tooltipProps: {
              content: cellAlert.message
            }
          });
        }
      }

      return null;
    }
    /**
     * Render row alert
     * @param {Object} rowAlert - Row alert to be rendered
     * @returns {ReactElement} - Row alert element
     */

  }, {
    key: "renderRowAlert",
    value: function renderRowAlert(rowAlert) {
      if (rowAlert) {
        var type;

        switch (rowAlert.type) {
          case _TableConstants.default.TABLE_ALERT.ERROR:
            type = _StatusIcon.default.STATUS_ICON_TYPES.ALERT;
            break;

          case _TableConstants.default.TABLE_ALERT.WARNING:
            type = _StatusIcon.default.STATUS_ICON_TYPES.WARNING;
            break;

          default:
            break;
        }

        if (type) {
          return _react.default.createElement(_StatusIcon.default, {
            className: "row-alert-icon",
            type: type,
            tooltipProps: {
              content: rowAlert.message
            }
          });
        }
      }

      return null;
    }
    /**
     * Get cell alert config object for this cell
     * @returns {object|null} - Cell alert object or null
     */

  }, {
    key: "getCellAlert",
    value: function getCellAlert() {
      var _this$props5 = this.props,
          column = _this$props5.column,
          columnKey = _this$props5.columnKey,
          rowData = _this$props5.rowData,
          rowKey = _this$props5.rowKey;
      var cellAlerts = this.props.cellAlerts || [];
      var cellAlert = null;

      for (var i = 0; i < cellAlerts.length; i++) {
        if (cellAlerts[i].row === rowData[rowKey] && cellAlerts[i].column === column[columnKey]) {
          cellAlert = cellAlerts[i];
          break;
        }
      }

      return cellAlert;
    }
  }]);

  return TableCell;
}(_react.default.Component);

exports.default = TableCell;
TableCell.CELL_EDIT_TYPES = CELL_EDIT_TYPES;
TableCell.defaultProps = {};
TableCell.propTypes = {
  /**
   * Array of cell alert configs
   */
  cellAlerts: _propTypes.default.arrayOf(_propTypes.default.object),

  /**
   * Unique key for a row.
   */
  columnKey: _propTypes.default.string,

  /**
   * Data source for column the cell belongs to
   */
  column: _propTypes.default.object,

  /**
   * Custom props to pass into table elements
   */
  customProps: _propTypes.default.object,

  /**
   * Object with direct edit config
   */
  editDirect: _propTypes.default.object,

  /**
   * Object with row edit config
   */
  editRow: _propTypes.default.object,

  /**
   * Table event handlers
   */
  eventHandlers: _propTypes.default.object,

  /**
   * Row alert config
   */
  rowAlert: _propTypes.default.object,

  /**
   * Data source for row the cell belongs to
   */
  rowData: _propTypes.default.object,

  /**
   * Index of row from data source
   */
  rowIndex: _propTypes.default.number,

  /**
   * Unique key for a row.
   */
  rowKey: _propTypes.default.string
};